import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/svg/splash/lp.svg';

import cl from './Header.module.scss';
import LogoApp from '../../assets/svg/logo_with_text.svg';

import {
  blockStateSelector,
  chatNotificationSelector,
  isAuthorizedSelector,
} from '../../redux/selectors';
import { useSelector } from 'react-redux';
import {
  SVGUpdatedLogoA,
  SVGUpdatedLogoB,
  SVGUpdatedLogoC,
  SVGprofilefont,
  SVGdirectoryfont,
  SVGinboxfont,
  SVGlistingsfont,
  SVGpartiesfont,
  SVGgoalsfont,
  SVGlogoutfont,
  SVGloader,
  SVGhomefont,
  SVGloginfont,
} from '../../assets/PackageSVG';

const LineLink = ({ to, name, children, isAuthorized }) => {
  const { pathname } = useLocation();
  const match = pathname.startsWith(to);

  const chatNotification = useSelector(chatNotificationSelector);

  return (
    <div className={cl.item}>
      <Link to={to}>
        <div
          className={[match ? cl.activeLine : '', cl.line].join(' ')}
          style={{
            border: isAuthorized && 'none',
            padding: isAuthorized && '0',
            backgroundColor: isAuthorized && 'transparent',
          }}
        >
          {children}
          <span
            style={{
              color: isAuthorized && match ? '#000' : isAuthorized && '#363636',
            }}
          >
            {name}
          </span>
          {name === 'Inbox' &&
            chatNotification &&
            !pathname.includes('chat') && (
              <div className={cl.inboxNotification}></div>
            )}
        </div>
      </Link>
    </div>
  );
};

//
//
//

const Header = () => {
  const isAuthorized = useSelector(isAuthorizedSelector);
  const blockState = useSelector(blockStateSelector);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  return (
    <div
      className={cl.wrapper}
      style={{
        backgroundColor: isAuthorized && '#fff',
        borderBottom: isAuthorized && 'grey',
      }}
    >
      {!isAuthorized && isHomePage ? (
        // New navigation design for non-authorized users on home page
        <nav className="flex flex-row justify-center items-center w-full h-full bg-gradient-to-r from-blue-900 via-purple-900 to-blue-800 text-white shadow-lg">
          <div className="flex flex-row justify-between items-center w-full max-w-[2900px] mx-[21px] px-0">
            <Link to="/" className="flex items-center">
              <SVGUpdatedLogoC width={200} className="h-auto" />
            </Link>
            <div className="flex gap-4">
              <button
                onClick={() => window.open('https://listperfectly.com/pricing/', '_blank')}
                className="px-6 py-2 bg-white text-blue-900 rounded-full font-semibold border-none cursor-pointer transition-all hover:bg-gray-100"
              >
                Sign Up
              </button>
              <button
                onClick={() => navigate('/login')}
                className="px-6 py-2 border-2 border-white rounded-full font-semibold bg-transparent text-white cursor-pointer transition-all hover:bg-white hover:text-blue-900"
              >
                Login
              </button>
            </div>
          </div>
        </nav>
      ) : (
        // Original header for authorized users or other pages
        <div className={cl.line}>
          <Link to="/">
            <div className={cl.logo}>
              {isAuthorized ? (
                <SVGUpdatedLogoA width={238} />
              ) : (
                <SVGUpdatedLogoC width={238} />
              )}
            </div>
          </Link>
          <div className={cl.menu}>
            {isAuthorized ? (
              <>
                <LineLink
                  to="/profile"
                  name="Profile"
                  isAuthorized={isAuthorized}
                >
                  <SVGprofilefont />
                </LineLink>

                {blockState?.noUsername === true ||
                blockState?.ban === true ? null : (
                  <>
                    <LineLink
                      to="/directory"
                      name="Directory"
                      isAuthorized={isAuthorized}
                    >
                      <SVGdirectoryfont />
                    </LineLink>
                    <LineLink to="/chat" name="Inbox" isAuthorized={isAuthorized}>
                      <SVGinboxfont />
                    </LineLink>
                    <LineLink
                      to="/listings"
                      name="Listings"
                      isAuthorized={isAuthorized}
                    >
                      <SVGlistingsfont />
                    </LineLink>
                    <LineLink
                      to="/events"
                      name="Events"
                      isAuthorized={isAuthorized}
                    >
                      <SVGpartiesfont />
                    </LineLink>
                    <LineLink
                      to="/goals"
                      name="Goals"
                      isAuthorized={isAuthorized}
                    >
                      <SVGgoalsfont />
                    </LineLink>
                    <LineLink
                      to="/logout"
                      name="Logout"
                      isAuthorized={isAuthorized}
                    >
                      <SVGlogoutfont />
                    </LineLink>
                  </>
                )}
              </>
            ) : (
              <>
                <LineLink to="/" name="Home" isAuthorized={isAuthorized}>
                  {/* <SVGhomefont /> */}
                </LineLink>
                <LineLink to="/login" name="Login" isAuthorized={isAuthorized}>
                  {/* <SVGloginfont /> */}
                </LineLink>
              </>
            )}
          </div>

          <div
            className={cl.rainbrow}
            style={{ visibility: isAuthorized && 'visible' }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Header;
